<template lang='pug'>
  i.svg-icon.svg-icon-openArrow
    svg(
      :fill='color'
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100'
    )
      path(d='M81.143,34.14l-2.12-2.139c-0.668-0.667-1.555-1.034-2.507-1.034c-0.948,0-1.839,0.368-2.508,1.034L49.799,56.212 L25.563,31.975c-0.666-0.667-1.557-1.034-2.506-1.034c-0.949,0-1.838,0.368-2.506,1.034l-2.123,2.124 c-1.382,1.379-1.382,3.631,0,5.012L47.285,68.07c0.667,0.669,1.556,1.138,2.515,1.138h0.009c0.951,0,1.839-0.469,2.504-1.138 l28.83-28.881c0.671-0.667,1.038-1.583,1.038-2.531C82.181,35.708,81.813,34.803,81.143,34.14z')

</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#333',
    },
  },

}
</script>